<script>
  import { onMount } from "svelte";
  import Layer from "./Layer.svelte";
  import {base_url, layers, layersInfo} from "./stores";

  function getObjectFitSize(
    contains /* true = contain, false = cover */,
    containerWidth,
    containerHeight,
    width,
    height
  ) {
    let doRatio = width / height;
    let cRatio = containerWidth / containerHeight;
    let targetWidth = 0;
    let targetHeight = 0;
    let test = contains ? doRatio > cRatio : doRatio < cRatio;

    if (test) {
      targetWidth = containerWidth;
      targetHeight = targetWidth / doRatio;
    } else {
      targetHeight = containerHeight;
      targetWidth = targetHeight * doRatio;
    }

    return {
      width: targetWidth,
      height: targetHeight,
      x: (containerWidth - targetWidth) / 2,
      y: (containerHeight - targetHeight) / 2,
    };
  }

  let w = 0;
  let h = 0;
  let layerInput;
  let base;
  let offsetX = 0;
  let offsetY = 0;
  let mounted = false;
  let right;
  onMount(() => {
    mounted = true;
  });

  let iw = 0;
  let ih = 0;

  $: {
    if (mounted) {
      let rect = base.getBoundingClientRect();
      offsetX = rect.left;
      offsetY = rect.top;

      let right_rect = right.getBoundingClientRect();
      w = right_rect.width;
      h = right_rect.height;
    }
  }

  $: {

    layersInfo.update(arr => {

      arr[0].dimensions = [iw, ih];

      return arr;

    });

  }
</script>

<div class="right" bind:this={right}>
  <div class="box" style={`width: ${w}px; height: ${h}px`}>
    <div class="layers">
      {#each $layers as lId (lId.name)}
        <Layer {offsetX} {offsetY} layerId={lId.name} layerType={lId.type} />
      {/each}
    </div>
    <img
      bind:this={base}
      class="base"
      alt="base"
      src={$base_url}
      draggable="false"
      on:load={(e) => {
        let o = getObjectFitSize(
          true,
          e.target.width,
          e.target.height,
          e.target.naturalWidth,
          e.target.naturalHeight
        );

        iw = o.width;
        ih = o.height;
      }}
    />
    <span class="dims">
      {iw.toFixed()}x{ih.toFixed()}
    </span>
  </div>
</div>

<style>
  .right {
    background-color: rgb(36, 39, 61);
    min-height: 100%;
    width: 80%;
  }

  .base {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: left top;
    user-select: none;
  }

  .layers {
    /* height: 100%; */
    /* width: 100%; */
    position: absolute;
    z-index: 20;
  }

  .dims {
    color: white;
    position: absolute;
    margin-top: 0.4rem;
    margin-left: -5.5rem;
    background-color: white;
    color: gray;
    padding: 0.2rem;
    border-radius: 3px;
    opacity: 0.6;
  }

  /*.layers-listing{*/

  /*  background-color: white;*/
  /*  opacity: 0.6;*/
  /*  padding: 0.1rem;*/
  /*  width: 30%;*/
  /*  text-align: center;*/

  /*}*/
  /*.layers-listing ul{*/

  /*  padding-left: 0;*/

  /*}*/

</style>
